import "src/css/widgets/widgets.css";
import ButtonActions from "src/components/agents/buttonactions";
import PhoneStatus from "src/components/widgets/agent/phonestatus";
import ChatStatus from "src/components/widgets/agent/chatstatus";
import FormStatus from "src/components/widgets/agent/formstatus";
import UserImage from "src/components/widgets/agent/userimage";
import useMonitorAPIService from 'src/services/monitorapiservice';
import { connect } from 'react-redux';
import React, { useState, useEffect } from 'react';
import { setShowChat, selectChat } from "src/redux/chatSlice";

function AgentCard(props) {

    const { transferCallToAgent } = useMonitorAPIService();
    const handleDrop = (e) => {
        let dataStr = e.dataTransfer.getData('text/plain');
        let data = JSON.parse(dataStr);
        var callToTransfer = {
            ext: data.ext !== null && data.ext.trim() !== "" ? data.ext : data.portExt,
            callId: data.id,
            pin: props.agent.pin,
            status: data.status,
            forceTransfer: false
        };

        transferCallToAgent(props.token, callToTransfer, e => {

        });
    };
    const [color, setColor] = useState("");
    useEffect(() => {
        let color = "";
        if (props.highlight) {
            if (props.agent.strStatus === "Talking") {
                color = "#009ef7";
            } else {
                switch (props.agent.strAcdStatus) {
                    case "Free":
                        color = "#4CAF50";
                        break;
                    case "Wrapup":
                        color = "#FF9800";
                        break;
                    case "Paused":
                        color = "#f1416c";
                        break;
                    default:
                        color = "#9E9E9E";
                        break;
                }

                if (props.agent.formOpen)
                    color = "#FF9800";
            }
        }
        setColor(color)
    }, [props.highlight, props.agent.strStatus, props.agent.strAcdStatus]);


    const handleDragOver = (e) => {
        e.preventDefault();
    };

    return (
        <span>
            <div className={"d-flex align-items-center me-1 mb-1"} style={{ width: "280px", height: "66px", padding: "5px", borderRadius: "10px", border: (props.highlight ? `5px solid ${color}` : "") }} onDrop={handleDrop} onDragOver={handleDragOver}>
                <UserImage agent={props.agent} />
                <div className="w-100">

                    <div className="fs-7 text-dark fw-bold w-100">{props.agent.name}
                        {
                            !props.hideOptions &&
                            <ButtonActions dashboard={true} agent={props.agent}
                                token={props.token}
                                record={props.record}
                                id={props.id}
                                functions={props.functions}
                                setShowChat={props.setShowChat}
                                selectChat={props.selectChat} />
                        }
                    </div>

                    <div className="fs-7 text-dark fw-bold">{props.agent.ext}
                        <span className="text-primary float-end">
                            <PhoneStatus agent={props.agent} />
                            <FormStatus agent={props.agent} />
                            <ChatStatus agent={props.agent} />
                        </span>
                    </div>

                    <div className="fs-7 text-dark fw-bold w-100">{props.agent.interlocutor || props.agent.interlocutorName}</div>
                </div>

            </div>
        </span>
    )
}

const mapStateToProps = (state) => {
    return {
        id: state.supervisor.id,
        token: state.supervisor.token,
        maxPauseTime: state.parameters.maxPauseTime,
        notify: state.parameters.notify,
        record: state.parameters.record,
        functions: state.supervisor.functions
    };
};

export default connect(mapStateToProps, { setShowChat, selectChat })(AgentCard);